__turbopack_export_value__({
  "body-logo-18": "DoctorsList-module-scss-module__ql8D3a__body-logo-18",
  "body-text-12": "DoctorsList-module-scss-module__ql8D3a__body-text-12",
  "body-text-14": "DoctorsList-module-scss-module__ql8D3a__body-text-14",
  "body-text-16": "DoctorsList-module-scss-module__ql8D3a__body-text-16",
  "body-text-18": "DoctorsList-module-scss-module__ql8D3a__body-text-18",
  "body-text-20": "DoctorsList-module-scss-module__ql8D3a__body-text-20",
  "body-text-24": "DoctorsList-module-scss-module__ql8D3a__body-text-24",
  "body-text-24-2": "DoctorsList-module-scss-module__ql8D3a__body-text-24-2",
  "body-text-heading-2": "DoctorsList-module-scss-module__ql8D3a__body-text-heading-2",
  "body-text-heading-3": "DoctorsList-module-scss-module__ql8D3a__body-text-heading-3",
  "body-text-medium-14": "DoctorsList-module-scss-module__ql8D3a__body-text-medium-14",
  "body-text-medium-16": "DoctorsList-module-scss-module__ql8D3a__body-text-medium-16",
  "body-text-medium-18": "DoctorsList-module-scss-module__ql8D3a__body-text-medium-18",
  "body-text-medium2-18": "DoctorsList-module-scss-module__ql8D3a__body-text-medium2-18",
  "body-text2-14": "DoctorsList-module-scss-module__ql8D3a__body-text2-14",
  "body-text2-16": "DoctorsList-module-scss-module__ql8D3a__body-text2-16",
  "button-primary-text": "DoctorsList-module-scss-module__ql8D3a__button-primary-text",
  "button-text": "DoctorsList-module-scss-module__ql8D3a__button-text",
  "button2-text": "DoctorsList-module-scss-module__ql8D3a__button2-text",
  "card-shadow": "DoctorsList-module-scss-module__ql8D3a__card-shadow",
  "doctors": "DoctorsList-module-scss-module__ql8D3a__doctors",
  "doctorsList": "DoctorsList-module-scss-module__ql8D3a__doctorsList",
  "doctors__pagination": "DoctorsList-module-scss-module__ql8D3a__doctors__pagination",
  "doctors__showMore": "DoctorsList-module-scss-module__ql8D3a__doctors__showMore",
  "effect-menu": "DoctorsList-module-scss-module__ql8D3a__effect-menu",
  "header-1": "DoctorsList-module-scss-module__ql8D3a__header-1",
  "main-container": "DoctorsList-module-scss-module__ql8D3a__main-container",
  "main-footer-container": "DoctorsList-module-scss-module__ql8D3a__main-footer-container",
  "main-header-container": "DoctorsList-module-scss-module__ql8D3a__main-header-container",
  "txt-12-bold": "DoctorsList-module-scss-module__ql8D3a__txt-12-bold",
  "txt-14-bold": "DoctorsList-module-scss-module__ql8D3a__txt-14-bold",
  "txt-14-bold-caps": "DoctorsList-module-scss-module__ql8D3a__txt-14-bold-caps",
  "txt-14-med": "DoctorsList-module-scss-module__ql8D3a__txt-14-med",
  "txt-16-bold": "DoctorsList-module-scss-module__ql8D3a__txt-16-bold",
  "txt-16-med": "DoctorsList-module-scss-module__ql8D3a__txt-16-med",
  "txt-18-bold": "DoctorsList-module-scss-module__ql8D3a__txt-18-bold",
  "txt-18-medium": "DoctorsList-module-scss-module__ql8D3a__txt-18-medium",
  "txt-18-medium-24": "DoctorsList-module-scss-module__ql8D3a__txt-18-medium-24",
  "txt-24-semi": "DoctorsList-module-scss-module__ql8D3a__txt-24-semi",
});
